export function createReducer(initialState: any, handlers: {}) {
    return function reducer(state: any = initialState, action: { type: string }) {
        return handlers.hasOwnProperty(action.type) ? handlers[action.type](state, action) : state;
    };
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/util.ts